import Container from "@mui/material/Container";
import { useEffect } from "react";
import { Outlet } from "react-router";

import ProgressSteps from "@/components/ProgressSteps/ProgressSteps";
import useTemplateNamesHandler from "@/hooks/useTemplateNamesHandler";

const UpdateDataView = () => {
  const { updateTemplateNamesList } = useTemplateNamesHandler();

  useEffect(() => {
    updateTemplateNamesList();
    // updateTemplateNamesList is recreated by useTemplateNamesHandler
    // on every render; intentionally fire only on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <ProgressSteps />
      <Outlet />
    </Container>
  );
};

export default UpdateDataView;
